import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/button';
import { Phone } from 'lucide-react';
import { WhatsAppIcon } from './WhatsAppIcon';
import { phoneRaw } from '../data/menuData';

const CTA_INITIAL = { opacity: 0, y: 20 };
const CTA_ANIMATE = { opacity: 1, y: 0 };
const CTA_TRANSITION = { duration: 0.5, delay: 0.7 };
const BUTTON_HOVER = { scale: 1.05 };
const BUTTON_TAP = { scale: 0.95 };

export const HeroCTAButtons = ({ callText }) => (
  <motion.div
    className="flex flex-wrap gap-3"
    initial={CTA_INITIAL}
    animate={CTA_ANIMATE}
    transition={CTA_TRANSITION}
  >
    <Button
      asChild
      className="rounded-full px-6 py-6 text-base font-semibold"
      data-testid="call-now-btn"
    >
      <motion.a
        whileHover={BUTTON_HOVER}
        whileTap={BUTTON_TAP}
        href={`tel:${phoneRaw}`}
      >
        <Phone className="mr-2 h-5 w-5" />
        {callText}
      </motion.a>
    </Button>
    <Button
      asChild
      variant="outline"
      className="rounded-full px-6 py-6 text-base font-semibold"
      data-testid="whatsapp-quick-btn"
    >
      <motion.a
        whileHover={BUTTON_HOVER}
        whileTap={BUTTON_TAP}
        href={`https://wa.me/${phoneRaw}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <WhatsAppIcon />
        WhatsApp
      </motion.a>
    </Button>
  </motion.div>
);
